
import { inputOnKeyUp } from "../../functions.ts";
import { useStore } from "../../state/state.ts";
import './info-button.css';

export default function InfoButton(props:{modal: ReactNode}){
    const push_modal = useStore((state) => state.push_modal_closeable);
    return <div 
        className="info-button-container"
        onClick={()=>{push_modal(props.modal);}}
        onKeyUp={(event)=>inputOnKeyUp(event, ()=>{push_modal(props.modal);})}
        role="button"
        aria-label="weitere informationen"
        tabIndex={0}
    >
            <span className="info-button">i</span>
    </div>
}